import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    roles: null,
  },
  getters: {
    isInitialized: state => state.isInitialized,
    roles: state => state.roles,
    // roles
    hasOrganizationRole: (state, getters, rootState, rootGetters) => role => {
      if (!state.roles) return false;
      const organization = rootGetters["organization/organization"]; // too yuck?
      if (!organization) return false;

      for (const organizationId of Object.keys(state.roles)) {
        if (state.roles[organizationId].some(r => r === "verensics-administrator")) return true;
        if (organizationId !== organization.id) continue;
        if (state.roles[organizationId].some(r => r === role)) return true;
      }

      return false;
    },
    isVerensicsAdministrator: (state, getters) => getters.hasOrganizationRole("verensics-administrator"),
    isOrganizationAdministrator: (state, getters) => getters.hasOrganizationRole("organization-administrator"),
    // report
    isReportCreator: (state, getters) => getters.hasOrganizationRole("report-creator"),
    isReportSummary: (state, getters) => getters.hasOrganizationRole("report-summary"),
    isReportViewer: (state, getters) => getters.hasOrganizationRole("report-viewer"),
    isReportDecisionEditor: (state, getters) => getters.hasOrganizationRole("report-editor-hire"),
    isReportAnswerEditor: (state, getters) => getters.hasOrganizationRole("report-editor-answers"),
    isReportCommenter: (state, getters) => getters.hasOrganizationRole("report-commenter"),
    // investigation
    isInvestigationCreator: (state, getters) => getters.hasOrganizationRole("investigation-creator"),
    isInvestigationSummary: (state, getters) => getters.hasOrganizationRole("investigation-summary"),
    isInvestigationViewer: (state, getters) => getters.hasOrganizationRole("investigation-viewer"),
  },
  mutations: {
    setRoles: (state, payload) => {
      state.roles = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["user/isInitialized"]);

      var user = context.rootGetters["user/user"];
      if (!user) {
        context.commit("setRoles", null);
        return;
      }

      await axios
        .get(`/v1/users/${user.id}/roles`)
        .then(res => context.commit("setRoles", res.data))
        .catch(() => context.commit("setRoles", null));
    },
  },
};
